import React, { Fragment } from 'react';
import { Button, Card, CardBody, Container, Row, Col, Input, } from 'reactstrap';
import { TableStriped } from '../../../components/tables/TableStriped';
import { useMicEstatus } from '../../../hooks/micEstatus/useMicEstatus';
import { ModalMicEstatus } from '../../../components/micEstatus/ModalMicEstatus';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexMicEstatus = () => {
    const {
        // * LIST
        estatusMic,

        //* CRUD TABLE
        handleCreate, closeDialog, method, modal, tittle,
        status, handleInputChange, titleDelete,
        saveCreate, loading, modalTitle,

        loadingExport, handleExportStatus, searchStatus, handleClear, handleSearch

    } = useMicEstatus();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };


    return (
        <>
            <Fragment>
                <div className='container-global-zoom'>
                    <Row>
                        <Col sm="12">
                            <Card>
                                <CardBody className="p-1">
                                    <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                                        <TitleDataTable
                                            titleTable="Listado de estatus"
                                            buttonActions={handleExportStatus}
                                            titleButton="Listado de estatus"
                                            isDisbled={loadingExport}
                                            loadingIsDisabled={loadingExport}
                                            titleCreate="Crear Estatus"
                                            buttonActionsCreate={handleCreate}
                                            actionInput={handleSearch}
                                            valueFilter={searchStatus}
                                            filterLocalStorage={true}
                                            cleanFilterLocalStorage={handleClear}
    
                                        />
                                    </Col>
                                
                                    <div className="table-responsive">
                                        <DataTable
                                            value={estatusMic}
                                            paginator
                                            rows={10}
                                            responsiveLayout="scroll"
                                            rowsPerPageOptions={[10, 50, 100]} 
                                            className="data-table p-datatable-striped p-datatable-sm"
                                            emptyMessage={
                                                <div className="text-center">
                                                    <img
                                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                        style={{ width: "32%" }}
                                                        alt="Sin resultados"
                                                    />
                                                    <br />
                                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                        No se encontraron resultados.
                                                    </p>
                                                </div>
                                            }
                                        >

                                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                            <Column field="status" header="Estatus" headerStyle={headerStyle} style={cellStyle} />
                                        </DataTable>
                                    </div>
                                </CardBody>
                            </Card>
                            {<ModalMicEstatus
                                {...{
                                    modal, tittle, closeDialog, method, modalTitle,
                                    status,
                                    handleInputChange, loading, titleDelete,
                                    saveCreate,
                                }}
                            />}
                        </Col>
                    </Row>
                </div>
            </Fragment>
        </>
    )
}
